"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "derovere": {
    "17448fb3": [{
      "hkey": "5c3fb106",
      "slug": "casalorzo-geroldi",
      "name": "Casalorzo Geroldi",
      "primary": true,
      "skipSearch": false
    }],
    "casalorso-geroldi": [{
      "hkey": "5c3fb106",
      "slug": "casalorzo-geroldi",
      "name": "Casalorzo Geroldi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;